import React from "react";
import { Outlet } from "react-router-dom";
import HeaderV2 from "./Header";
import styled from "styled-components";
import "./v2styles.css";
import FooterV2 from "./FooterV2";

const WhiteBackgroundWrapper = styled.div`
  position: relative;
  background-color: white;
  position: relative;
  min-height: 100vh;
  overflow-y: auto;
`;

const WhiteBackground = ({ children }) => {
  return (
    <WhiteBackgroundWrapper className="prototype">
      {children}
    </WhiteBackgroundWrapper>
  );
};

function PrototypeShell(props) {
  return (
    <>
      <WhiteBackground>
        <HeaderV2 isMobile={props.isMobile} />
        <Outlet></Outlet>
        <FooterV2 isMobile={props.isMobile} />
      </WhiteBackground>
    </>
  );
}

export default PrototypeShell;
